// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"120":"314f0ff4","426":"7e274318","803":"8ee479b2","995":"b2aa14dc"}[chunkId] + ".js";
};